import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=09d169ce&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Products.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Products.vue?vue&type=style&index=0&id=09d169ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d169ce",
  null
  
)

export default component.exports